import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';
import {BackgroundComponent} from '../background/background.component';
import {FontComponent} from '../font/font.component';

@Component({
  selector: 'app-widget-style',
  imports: [
    BackgroundComponent,
    FontComponent
  ],
  templateUrl: './widget-style.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './widget-style.component.scss'
})
export class WidgetStyleComponent extends AbstractStyleComponent {
  @ViewChild('background') backgroundComponent!: BackgroundComponent;
  @ViewChild('font') fontComponent!: FontComponent;

  getValue(): any {
    return {
      background: this.backgroundComponent.getValue(),
      font: this.fontComponent.getValue(),
    };
  }

  setValue(value: any): void {
    this.backgroundComponent.setValue(value['background']);
    this.fontComponent.setValue(value['font']);
  }
}
